<template>
    <div class="account-concent">
        <div class="account-box">
            <!-- col-sm-12 col-xs-22 -->
            <div class="avatar-box">
                <img class="avatar cursor-pointer" :src="detail.avatar" @click="choose = true" />
                <img class="avatar-edit cursor-pointer" src="@/assets/images/avatar-edit.png" @click="choose = true" />
            </div>
            <div style="max-width: 28rem">
                <el-descriptions :column="1" :colon="false" :labelStyle="{ 'font-size': '1rem', width: '8.75rem' }" :contentStyle="{ 'font-size': '1rem' }">
                    <el-descriptions-item :label="$t('studentProgramme.accountName')">{{ detail.userNo }}</el-descriptions-item>
                    <el-descriptions-item :label="$t('studentProgramme.subscriptionStatus')">
                        <div v-if="!isNaN(detail.subscriptionIndex)">
                            <span
                                :class="
                                    checkDate(detail.subscriptions[detail.subscriptionIndex].endDate,detail.branchSchool) != 0
                                        ? 'text-warn'
                                        : ((detail.subscriptions[detail.subscriptionIndex].upgradeWill == 1 && detail.subscriptions[detail.subscriptionIndex].upgradedType == 1) ||
                                              detail.subscriptions[detail.subscriptionIndex].upgradeWill == 2) &&
                                          detail.gradeId != 6
                                        ? 'text-info'
                                        : 'text-success'
                                "
                            >
                                {{
                                    checkDate(detail.subscriptions[detail.subscriptionIndex].endDate,detail.branchSchool) == 0
                                        ? $t("studentProgramme.active")
                                        : checkDate(detail.subscriptions[detail.subscriptionIndex].endDate,detail.branchSchool) == 1
                                        ? $t("studentProgramme.soon")
                                        : $t("studentProgramme.end")
                                }}
                            </span>
                            <span>{{ detail.branchSchool!=null && detail.branchSchool.abbreviation!='HQ'?"":"(" + formatDate(detail.subscriptions[detail.subscriptionIndex].endDate) + $t("studentProgramme.end")+")" }}</span>
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item :label="$t('studentProgramme.myGrade')">
                        <div v-if="!isNaN(detail.subscriptionIndex)">
                            {{ detail.subscriptions[detail.subscriptionIndex].gradeName }}
                            {{ `(${detail.subscriptions[detail.subscriptionIndex].totalStar}/${detail.subscriptions[detail.subscriptionIndex].fullStar} `+$t("studentProgramme.star")+")" }}
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item :label="$t('studentProgramme.myGender')">
                        <div v-if="detail.gender == 0 || detail.gender == 1">{{ genders[detail.gender].label }}</div>
                        <div v-else>---</div>
                    </el-descriptions-item>
                    <el-descriptions-item :label="$t('studentProgramme.myBirthday')"
                        ><div>{{ formatDate(detail.birthday) || "---" }}</div></el-descriptions-item
                    >
                    <el-descriptions-item :label="$t('studentProgramme.branchSchool')">
                      <div v-if="detail.branchSchool != null">
                        {{ detail.branchSchool.abbreviation }}-{{ detail.branchSchool.nameZh }}
                      </div>
                      <div v-else>HQ</div>
                    </el-descriptions-item>
                  <el-descriptions-item :label="$t('studentProgramme.courseVersion')">
                    <div>
                      {{detail.studying==0?'香港數學課程':'Hong Kong Mathematics Curriculum'}}
                    </div>
                  </el-descriptions-item>
                </el-descriptions>
            </div>
        </div>
        <el-dialog :visible.sync="choose" width="70%" top="0" :show-close="false">
            <div class="choose-box">
                <div class="close-button cursor-pointer" @click="cancelChoose">✕</div>
                <div style="margin-top: 2rem; font-size: 2rem; line-height: 2rem; font-weight: bold; color: #b62d2e">{{ $t("studentProgramme.setPicture") }}</div>
                <div style="font-size: 2rem; margin: 2rem">{{ $t("studentProgramme.choosePicture") }}</div>
                <el-radio-group @change="onRadioChange" v-model="avatar" class="col-sm-11">
                    <el-row type="flex" style="flex-wrap: wrap">
                        <el-col v-for="(item, index) in avatars" :key="index" :span="8">
                            <el-radio :label="item">
                                <img class="avatar" :src="item" />
                            </el-radio>
                        </el-col>
                    </el-row>
                </el-radio-group>
                <button class="col-sm-6 col-xs-16 button cursor-pointer" @click="updateAvatar">{{ $t("studentProgramme.update") }}</button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { gender } from "@/biz/static-data";
import { getProfile, updateAvatar } from "@/api/user";
import { formatDate } from "@/filters";
import { setUserInfo } from "@/utils/auth";
import moment from "moment";
import cmi from "../cmi";
export default {
    props: {
        detail: {
            type: Object,
            default: function () {},
        },
    },
    data() {
        return {
            state: 2,
            choose: false,
            avatar: null,
            avatars: [],
        };
    },
    watch: {
        "$store.getters.language": {
            handler(v) {
                this.genders = gender[v];
                this.$forceUpdate();
            },
            deep: true,
        },
        detail() {
            this.$forceUpdate();
        },
    },
    created() {
        this.getAvatars();
    },
    mounted() {
        this.getProfile();
    },
    methods: {
        getProfile() {
            getProfile().then((v) => {
                let detail = JSON.parse(JSON.stringify(v.data));
                // let now = new Date().getTime();
                // detail.subscriptionIndex = detail.subscriptions.findIndex((item) => {
                //     return new Date(item.startDate).getTime() < now && new Date(item.endDate).getTime() > now;
                // });
                detail.subscriptionIndex = 0
                this.$emit("update:detail", detail);
                setUserInfo("userProfile", detail);
                // this.$store.dispatch('setGradeId', detail.subscriptions[detail.subscriptionIndex].gradeId);
                this.$set(detail, "gradeId", detail.grade?.id || detail.subscriptions[detail.subscriptionIndex].gradeId);
            });
        },
        cancelChoose() {
            this.choose = false;
            this.avatar = null;
        },
        onRadioChange(v) {
            this.avatar = v;
        },
        formatDate(date) {
            return formatDate(date);
        },
        getThreeMonthAgo(endDate) {
            var a = moment();
            var b = moment(endDate);
            return b.diff(a, "months");
        },
        //0:30天外,订阅中；1:30天内,即将过期;2:过期;3:到期(当天)
        checkDate(endDate,branchSchool) {
            let status = 0;
            if (this.getThreeMonthAgo(endDate) <= 3) {
                status = 1;
            }
            if (moment().format("YYYY-MM-DD") == moment(endDate).format("YYYY-MM-DD")) {
                status = 3;
            }
            if (moment().format("YYYY-MM-DD") > moment(endDate).format("YYYY-MM-DD")) {
                status = 2;
            }
          //分校学生：订阅中
          if(branchSchool != null){
            if(branchSchool.abbreviation != 'HQ'){
              status = 0;
            }
          }
            return status;
        },
        getAvatars() {
            let list = ["/avatars/avatar_1.jpg", "/avatars/avatar_2.jpg", "/avatars/avatar_3.jpg", "/avatars/avatar_4.jpg", "/avatars/avatar_5.jpg", "/avatars/avatar_6.jpg"];
            this.avatars = list.map((item) => {
                return `${process.env.VUE_APP_URL}` + item;
            });
        },
      updateAvatar() {
            this.choose = false;
            let detail = JSON.parse(JSON.stringify(this.detail));
            detail.avatar = this.avatar;
          updateAvatar(detail).then(() => {
                cmi.$emit("avatarChange", this.avatar);
                this.detail.avatar = this.avatar;
                this.detail.firstLogin = 1;
                setUserInfo("userProfile", this.detail);
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.account-concent {
    display: flex;
    height: 100%;
    //min-height:calc(100vh - 4.5rem);//100vh - 4.5rem - 9.375rem - 4vw
    padding: 9.375rem 4vw 4vw;
}
.account-box {
    border-radius: 2.5rem;
    background: #ffffff;
    margin: auto;
    display: flex;
    padding: 4vw 2rem;
}
.avatar-box {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 2rem 4rem 2rem 2rem;
    .avatar {
        width: 12rem;
        height: 12rem;
    }
    .avatar-edit {
        position: absolute;
        margin-top: 9.25rem;
        margin-left: 9.25rem;
        width: 2.75rem;
        height: 2.75rem;
        background: #f1aa55;
        border-radius: 50%;
        box-shadow: 0px 0.25rem 0 #c28c00;
    }
}
.text-warn {
    color: #d20000;
}
.text-success {
    color: #008000;
}
.text-info {
    color: #936a10;
}
.choose-box {
    background: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    .close-button {
        position: absolute;
        top: -32px;
        right: -32px;
        background: #b62d2e;
        box-shadow: 0px 0.5rem 0 #890e0f;
        width: 4rem;
        height: 4rem;
        border-radius: 50%;
        color: white;
        font-size: 40px;
        font-weight: bold;
        line-height: 64px;
        text-align: center;
    }
    .avatar {
        width: 100%;
        border: 1rem solid #ffffff;
        border-radius: 50%;
    }
    .is-checked .avatar {
        border: 1rem solid #fcc03a;
    }
    .button {
        background: #fcc03a;
        box-shadow: 0px 0.5rem 0 #c28c00;
        border: none;
        border-radius: 2.75rem;
        font-size: 2rem;
        margin: 2rem;
        display: block;
    }
}
@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
    .account-concent {
        min-height: calc(100vh - 3.5rem);
    }
    .account-box {
        flex-direction: column;
    }
}
::v-deep {
    .el-dialog__wrapper {
        display: flex;
        align-items: center;
        .el-dialog__header {
            padding: 0;
        }
        .el-dialog {
            margin: 0 auto;
            border-radius: 2.5rem;
            .el-radio__input {
                display: none;
            }
            .el-radio__label {
                padding: 0;
            }
        }
    }
}
</style>
